export { default } from "./GameErrorBoundary";
